import { FILE_TYPES } from "../constants";
import { store } from "../store";
import { alertActions } from "../store/actions";

const bankSlip = [
    "image/jpeg", "image/jpg", "image/png", "application/pdf"
]

export const validateFileFormat = (uploadType, fileType) => {
    let validFormat = false;
    switch (uploadType) {

        case FILE_TYPES.BANK_SLIP:
            bankSlip.forEach(type => {
                if (type == fileType)
                    validFormat = true;
            });
            if (!validFormat)
            store.dispatch(alertActions.error("Invalid file format"));
            return validFormat;

        default:
            break;
    }
}